<mf-global-spinner />
<router-outlet />
<app-notification-area />
